import * as React from 'react';
import styles from './index.less';
import { Input, InputRef } from 'antd';
import { ChangeEventHandler, KeyboardEventHandler } from 'react';
import { FUtil } from '@freelog/tools-lib';
import * as AHooks from 'ahooks';

interface FInput_Search_Props {
  value: string;
  placeholder?: string;
  className?: string;
  size?: 'small' | 'middle';
  style?: React.CSSProperties;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  onPressEnter?: KeyboardEventHandler<HTMLInputElement>;
}

function FInput_Search(
  {
    value,
    placeholder = '',
    className = '',
    size = 'middle',
    style = {},
    onChange,
    onPressEnter,
  }: FInput_Search_Props,
  ref: React.Ref<InputRef> | undefined,
) {
  const [$syncParent, set$syncParent, get$syncParent] = FUtil.Hook.useGetState<boolean>(true);
  const [$value, set$value, get$value] = FUtil.Hook.useGetState<string>('');

  AHooks.useDebounceEffect(
    () => {
      if (value !== get$value()) {
        set$value(value);
      }
    },
    [value],
    {
      wait: 10,
    },
  );

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    if (get$syncParent()) {
      onChange?.(event);
      set$value(event.target.value);
    } else {
      set$value(event.target.value);
    }
  }

  return (
    <Input
      ref={ref}
      value={$value}
      placeholder={placeholder}
      className={[...className, styles.FInput_Search].join(' ')}
      style={{
        height: size === 'middle' ? 38 : 32,
        ...style,
      }}
      prefix={<i className={['freelog', 'fl-icon-content', styles.darkPrefix].join(' ')} />}
      onChange={handleChange}
      onPressEnter={onPressEnter}
      allowClear={true}
      onCompositionStart={() => {
        set$syncParent(false);
      }}
      onCompositionEnd={(event: React.CompositionEvent<HTMLInputElement>) => {
        set$syncParent(true);
        handleChange(event as unknown as React.ChangeEvent<HTMLInputElement>);
      }}
    />
  );
}

export default React.forwardRef(FInput_Search);
